import { Level } from 'simple-logging-lib';
export class ErrorLevelFilter {
  isLoggable(record) {
    return record.level === Level.ERROR;
  }
}